import type { AppsUnavailableReason, CommercialBasis } from '../../types/api';
import type { ResourceError } from './useAdminResource';

/** Page size the directory asks for. The server allows up to 100. */
export const DIRECTORY_PAGE_SIZE = 25;

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '—' : d.toLocaleString();
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '—' : d.toLocaleDateString();
}

export function yesNo(value: boolean): string {
  return value ? 'Yes' : 'No';
}

/** `owner` -> `Owner`, `past_due` -> `Past due`. */
export function humanize(value: string | null | undefined): string {
  if (!value) return '—';
  const spaced = value.replace(/[_-]+/g, ' ').trim();
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}

export function formatNumber(value: number): string {
  return value.toLocaleString();
}

export const APPS_UNAVAILABLE_TEXT: Record<AppsUnavailableReason, string> = {
  membership_not_active: 'Not shown: their membership is not active.',
  workspace_closed: 'Not shown: this workspace is closed.',
  no_subscription_yet:
    'Not worked out yet: this workspace has no plan record. It gets one the first time someone opens it.',
  lookup_failed: 'Could not load apps for this workspace.',
};

export const PLAN_BASIS_TEXT: Record<CommercialBasis, string> = {
  free: 'Free plan',
  paid: 'Paid subscription',
  paid_grace: 'Payment overdue, still in the grace period',
  local_trial: 'In trial',
  grandfathered: 'Older account that keeps its plan',
  commercial_grandfather: 'Kept the plan it had before paid plans started',
  staging_fixture: 'Staging test setup',
  unpaid: 'Not paid, so the free plan applies',
  no_plan: 'No plan found',
};

/** What to tell the admin when a directory request failed. */
export function describeError(error: ResourceError, what: string): string {
  if (error.status === 404) return `${what} was not found.`;
  if (error.status === 400) return `That link is not valid: ${error.message}.`;
  if (error.status === 403) return 'You need Central admin access to see this.';
  if (error.status === 0) return error.message;
  return `Could not load ${what.toLowerCase()}. ${error.message}`;
}
